export default {
  'get-list': {
    method: 'post',
    url: '/client'
  },
  add: {
    method: 'post',
    url: '/client'
  },
  delete: {
    method: 'delete',
    url: '/client'
  },
  update: {
    method: 'PUT',
    url: '/client/driver/document/file/ID'
  },
  changeStatus: {
    method: 'put',
    url: '/client'
  },
  archive: {
    method: 'DELETE',
    url: '/client/driver/document/archive'
  },
  restore: {
    method: 'PUT',
    url: '/client/driver/document/restore'
  }
}
